// This keeps the repo free of a hard dependency while providing the
// small API surface the app expects during/after migration to PrimeNG.

// Export simple TREE_ACTIONS with a couple of no-op helpers used in the codebase.
export const TREE_ACTIONS: any = {
  MOVE_NODE: (_tree: any, _node: any, _event: any, _opts?: any) => {
    // noop – consumer code should handle actual data moves
    return null;
  },
  TOGGLE_EXPANDED: (tree: any, node: any, _event: any) => {
    if (!node) return;
    if (typeof node.isExpanded === 'boolean') node.isExpanded = !node.isExpanded;
    if (typeof node.expanded === 'boolean') node.expanded = !node.expanded;
    // attempt to call any provided expand/collapse helpers
    if (node.expand && typeof node.expand === 'function') node.expand();
    return null;
  }
};

// Key constants used by some components when mapping keyboard actions.
export const KEYS: any = {
  ENTER: 'ENTER',
  SPACE: 'SPACE',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
  UP: 'UP',
  DOWN: 'DOWN'
};

// Type shims (TypeScript types only, runtime is just any)
export type TreeComponent = any;
export type TreeModel = any;
export type TreeNode = any;
export type IActionMapping = any;

// Dragged element placeholder used in some module declarations
export class TreeDraggedElement {
  constructor(public data?: any) {}
}

export default {};
